import React from 'react';
import {Router, Route} from 'react-router';

import App from './components/App';

import {goToStoryBySlug, setLanguage} from './state/actions/timeline';

export default function routes(history, store) {

    function loadStory(store, nextState) {
        store.dispatch(goToStoryBySlug(nextState.params.slug));

        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }

    function loadLanguage(store, nextState) {
        store.dispatch(setLanguage(nextState.params.language));
    }

    return (
        <Router history={history} {...store}>
            <Route path="/(:language/)pagina/about" component={App} onEnter={(nextState) => {
                loadLanguage(store, nextState)
            }}>
            </Route>
            <Route path="/(:language/)artikel/:slug"
                   component={App} onEnter={(nextState) => {
                loadStory(store, nextState);
                loadLanguage(store, nextState);
            }}>
            </Route>
            <Route path="/(:language)"
                   component={App} onEnter={(nextState) => {
                loadStory(store, nextState);
                loadLanguage(store, nextState)
            }}>
            </Route>
        </Router>
    )
}


// WEBPACK FOOTER //
// ./src/routes.js